import { getWindowData, type LocationData } from "owa-window-data";

export function getHostLocation(): LocationData {
    return getWindowData().location;
}
